import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBIntFieldObjective, DBDropDown } from '_components';
import styles from './Behavioral.module.css';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveBehavioral extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            passed: this.props.passedTestvalue,
            total: this.props.totalTestvalue,
            dropdownValue: this.props.effortDDLvalue,
            dropdownManuallyChanged: false
        };

        this.handlePassedChange = this.handlePassedChange.bind(this);
        this.handleTotalChange = this.handleTotalChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
    }
    handlePassedChange(e) {
        const val = parseInt(e);
        if (!isNaN(val) && val >= 0) {
            this.setState({ passed: val }, () => {
                this.autoSelectDropdown();
            });
        } else if (e === '') {
            this.setState({ passed: '' });
        }
    }

    handleTotalChange(e) {
        const val = parseInt(e);
        if (!isNaN(val) && val >= 0) {
            this.setState({ total: val }, () => {
                this.autoSelectDropdown();
            });
        } else if (e === '') {
            this.setState({ total: '' });
        }
    }

    handleDropdownChange(e) {
        this.setState({
            dropdownValue: e.target.value,
            dropdownManuallyChanged: true
        });
    }

    autoSelectDropdown() {
        const { passed, total, dropdownManuallyChanged } = this.state;

        if (
            passed !== '' &&
            total !== '' &&
            !dropdownManuallyChanged
        ) {
            const passedValue = parseInt(passed);
            const totalValue = parseInt(total);
    
            let effort;
    
            if (passedValue >= 6) {
                effort = 'Maximal effort';
            } else {
                effort = passedValue < totalValue
                    ? 'Submaximal effort'
                    : 'Maximal effort';
            }
    
            this.props.updateTextField(
                this.props.noteId,
                'PTOBJECTIVEOBS',
                'OONO',
                this.props.oono,
                'OOBEHAVEEFFORT',
                effort
            );
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='behavioral' name='Behavioral' refProp={this.props.refProp} level={5}>
                <div className={styles.row}>
                <label className={styles.col1}>Validity Testing: Client passed </label>
                <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEOBS'
                     entityKeyColumn='OONO'
                     entityKeyValue={this.props.oono}
                     field='OOBEHAVEPASSEDTESTS'
                     className={styles.field}
                     max={this.state.total !== '' && this.state.total !== undefined ? this.state.total: null}
                     min={0}
                     onChange={(e)=>this.handlePassedChange(e)}
                />
                <label className={styles.col2}> of </label>
                <DBIntFieldObjective
                     noteId={this.props.noteId}
                     entity='PTOBJECTIVEOBS'
                     entityKeyColumn='OONO'
                     entityKeyValue={this.props.oono}
                     field='OOBEHAVETOTALTESTS'
                     className={styles.field}
                     min={this.state.passed}
                     onChange={(e)=>this.handleTotalChange(e)}
                />
                  <label className={styles.col3}>validity tests indicating</label>
                  <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOBEHAVEEFFORT'
                        onChange={(e)=> this.handleDropdownChange(e)}
                        customOptions={
                            [
                                { id: 'Submaximal effort', value: 'Submaximal effort' },
                                { id: 'Maximal effort', value: 'Maximal effort' }
                            ]
                        }
                    />
                </div>
            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId,
        oono,
        totalTestvalue: state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVETOTALTESTS'] !== undefined
        && state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVETOTALTESTS'] !== null ?
        state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVETOTALTESTS'] : '',
        passedTestvalue: state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEPASSEDTESTS'] !== undefined
        && state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEPASSEDTESTS'] !== null ?
        state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEPASSEDTESTS'] : '',
        effortDDLvalue: state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEEFFORT'] !== undefined
        && state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEEFFORT'] !== null ?
        state.entities.notes['PTOBJECTIVEOBS'][oono]['OOBEHAVEEFFORT'] : ''
    };
}

const connectedPatientCareCenterNoteObjectiveBehavioral = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveBehavioral);
export { connectedPatientCareCenterNoteObjectiveBehavioral as PatientCareCenterNoteObjectiveBehavioral };

